import {LOCAL_STORAGE_KEYS, SETTING_DEFAULT_UNITS} from "constants/AppConstants.js";
import LocalStorageService from "services/LocalStorageService.js";

export default class UnitService {
  static getSpeedUnit(): string {
    const speedUnit = LocalStorageService.get(LOCAL_STORAGE_KEYS.settingSpeedUnit);
    if (speedUnit) return speedUnit;
    return SETTING_DEFAULT_UNITS.speed;
  }

  static getDistanceUnit(): string {
    const distanceUnit = LocalStorageService.get(LOCAL_STORAGE_KEYS.settingDistanceUnit);
    if (distanceUnit) return distanceUnit;
    return SETTING_DEFAULT_UNITS.distance;
  }

  static getWindUnit(): string {
    const windUnit = LocalStorageService.get(LOCAL_STORAGE_KEYS.settingWindUnit);
    if (windUnit) return windUnit;
    return SETTING_DEFAULT_UNITS.wind;
  }
}
